import { AlgorithmRepository, Engine, ExecutionEnvironment } from '@telespot/domain';

export interface RetrieveAlgorithmOutput {
  id: string;
  name: string;
  version: string;
  description: string;
  regulated: boolean;
  deprecated: boolean;
  environment: ExecutionEnvironment;
  numOrganizations: number;
  numWorkspaces: number;
  outputLabels: Set<string>;
  engine: Engine | undefined;
}

export interface IRetrieveAlgorithmQuery {
  /**
   * Retrieves a single algorithm by id, projected to the fields needed by the
   * UI (basic metadata plus compatibility-relevant fields like outputLabels
   * and engine). Repository errors propagate so the caller can update its
   * error state.
   */
  execute(algorithmId: string): Promise<RetrieveAlgorithmOutput>;
}

export class RetrieveAlgorithmQuery implements IRetrieveAlgorithmQuery {
  constructor(private readonly algorithmRepository: AlgorithmRepository) {}

  public async execute(algorithmId: string): Promise<RetrieveAlgorithmOutput> {
    const algorithm = await this.algorithmRepository.getById(algorithmId);
    return {
      id: algorithm.id,
      name: algorithm.name,
      version: algorithm.version,
      description: algorithm.description,
      regulated: algorithm.regulated,
      deprecated: algorithm.deprecated,
      environment: algorithm.environment,
      numOrganizations: algorithm.numOrganizations,
      numWorkspaces: algorithm.numWorkspaces,
      outputLabels: algorithm.outputLabels,
      engine: algorithm.engine,
    };
  }
}
